import React, { FC, ReactNode } from 'react';
import classNames from 'classnames';

import css from './style.module.scss';
import MessageForm from '../../MessageForm';
import ChatHeader from '../../ChatHeader';
import setQaAttribute from '../../../helpers/setQaAttribute';
import { SUPPORT_CHAT_WINDOW } from '../../../constants/qaAttributes';

interface IProps {
  children: ReactNode;
  hideControls?: boolean;
  isMobile?: boolean;
}

const Chat: FC<IProps> = ({ children, hideControls, isMobile }) => (
  <div
    className={classNames(css.chat, { [css.isMobile]: isMobile })}
    {...setQaAttribute(SUPPORT_CHAT_WINDOW)}
  >
    <ChatHeader />
    <div className={css.chat__body}>{children}</div>
    {!hideControls && <MessageForm />}
  </div>
);

export default Chat;
